import { Reducer } from 'redux';

import { FeedLoadFulfilledAction } from '../../domains/feedLoad/actions.types';

import { TargetingRules } from './types';

export type TargetingRuleAction = FeedLoadFulfilledAction;

const initialState: TargetingRules = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TargetingRules, TargetingRuleAction> = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
